import { UnitConversionKey } from '@/enums/unit-conversion-key.enum';
import { useQuery } from '@/hooks/query.hook';
import { Menu } from 'antd';
import { MenuClickEventHandler } from 'rc-menu/lib/interface';
import { useState } from 'react';

type UnitConversionMenuProps = {
  onSelectMenuItem: (key: string) => void;
};

export const UnitConversionMenu = ({
  onSelectMenuItem
}: UnitConversionMenuProps) => {
  const { push, conversionKey } = useQuery();
  const [openKeys, setOpenKeys] = useState<string[]>([
    conversionKey?.substring(0, 1) ?? UnitConversionKey.BloodSugar
  ]);

  const handleClick: MenuClickEventHandler = (e) => {
    onSelectMenuItem(e.key);

    push(`${location.pathname}?conversionKey=${e.key}`, { replace: true });
  };

  const handleOpenChange = (keys: string[]) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key)) || '';
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  const items = [
    {
      key: UnitConversionKey.BloodSugar,
      label: 'Đường huyết',
      children: [
        { key: UnitConversionKey.BloodSugarFasting, label: 'Đường huyết lúc đói' },
        { key: UnitConversionKey.BloodSugar2H, label: 'Đường huyết sau 2 giờ uống' },
        { key: UnitConversionKey.BloodSugarHbA1c, label: 'HbA1c' }
      ]
    },
    {
      key: UnitConversionKey.UreCreatinine,
      label: 'Chức năng thận',
      children: [
        { key: UnitConversionKey.Urea, label: 'Urea' },
        { key: UnitConversionKey.Creatinine, label: 'Creatine' }
      ]
    },
    {
      key: UnitConversionKey.LiverEnzyme,
      label: 'Chức năng gan',
      children: [
        { key: UnitConversionKey.LiverEnzymeSgot, label: 'SGOT/ALT' },
        { key: UnitConversionKey.LiverEnzymeSgpt, label: 'SGPT/AST' }
      ]
    },
    {
      key: UnitConversionKey.Lipid,
      label: 'Mỡ máu',
      children: [
        { key: UnitConversionKey.LipidCholesterol, label: 'Cholesterol' },
        { key: UnitConversionKey.LipidLdl, label: 'LDL' },
        { key: UnitConversionKey.LipidHdl, label: 'HDL' },
        { key: UnitConversionKey.LipidTriglyceride, label: 'Triglyceride' }
      ]
    },
    {
      key: UnitConversionKey.UricAcid,
      label: 'Axit Uric'
    }
  ];

  return (
    <Menu
      mode='inline'
      defaultSelectedKeys={[UnitConversionKey.BloodSugar]}
      selectedKeys={[conversionKey || UnitConversionKey.BloodSugarFasting]}
      onClick={handleClick}
      openKeys={openKeys}
      onOpenChange={handleOpenChange}
      items={items}
      // style={{width: 250}}
    />
  );
};
